import React from 'react';
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  useMediaQuery,
  Theme,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from '../state';

const StyledText = styled(Typography)({
  opacity: 0.5,
  fontWeight: 500,
});

interface Props {
  children: JSX.Element;
  selector: (state: AppState) => boolean;
}

const FiltersLayoutHandler = ({ children, selector }: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [expanded, setExpanded] = React.useState(false);
  const loading = useSelector(selector);

  React.useEffect(() => {
    if (loading) setExpanded(false);
  }, [loading]);

  const togglePanel = () => {
    setExpanded(state => !state);
  };

  if (isMobile)
    return (
      <Accordion expanded={expanded} data-guide="report-filters-panel">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={togglePanel} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <StyledText>{t('toolbar.labels.filters')}</StyledText>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    );
  return <Box data-guide="report-filters-panel">{children}</Box>;
};

export default FiltersLayoutHandler;
